import OLLayerTile from 'ol/layer/Tile'

import type { TileImage } from 'ol/source'

import type { ConfigLayerOptions } from 'config/ConfigLayer'
import type { ConfigLayerBaseTileOptions } from 'config/ConfigLayerBaseTileOptions'
import { MapLayer } from 'config/MapLayer'

export class MapLayerNone extends MapLayer {
  static createLayer (layerConf: ConfigLayerOptions): OLLayerTile<TileImage> {
    this.preLayer(layerConf)

    const baseTileOptions: ConfigLayerBaseTileOptions = {
      title: layerConf.title,
      titleid: layerConf.titleid,
      group: layerConf.group,
      source: undefined,
      visible: false
    }
    return new OLLayerTile(baseTileOptions)
  }
}
